import '@babel/polyfill';

// Required by Axios
import 'es6-promise/auto';
import 'isomorphic-fetch';
import 'intersection-observer';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import get from 'lodash/get';

import { configureStore } from 'config/store';
import AppContainer from 'base-ordering/base/containers/AppContainer';
import { initializeSentry } from 'config/sentry';
import { bootStrapAccount } from 'bento-ordering/account/actions';
import { exposeMomentForIntegrationTests } from 'test/testUtils';

initializeSentry();

const store = configureStore();

exposeMomentForIntegrationTests();

if (get(window.bentoboxOnlineOrdering, 'account')) {
  store.dispatch(bootStrapAccount());
}

ReactDOM.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>,
  document.getElementById('app')
);
